import { Component, ComponentRef, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, ViewChild, ViewContainerRef } from '@angular/core';
import { Choice, FilterDefinition } from '@model';
import { BaseFilterComponent } from '@core/components';
import { SxDynamicFilterComponentsService } from '@services';

@Component({
    selector: 'app-filter-wrapper',
    templateUrl: './filter-wrapper.component.html',
    standalone: false
})
export class FilterWrapperComponent implements OnInit, OnChanges, OnDestroy {
  @Output()
  value: Array<string>;

  @Output()
  valueChanged = new EventEmitter<FilterDefinition>();

  @Input()
  filter: FilterDefinition;

  @ViewChild('tpl', { read: ViewContainerRef, static: true })
  card: ViewContainerRef;
  component: ComponentRef<BaseFilterComponent>;
  filterComponent: BaseFilterComponent;
  hasBeenInjected = false;

  selections: Choice[] = [];

  _label: string;
  isChanged: boolean;

  showSelected = false;

  constructor(private dynamicFilterComponentService: SxDynamicFilterComponentsService) {}

  ngOnInit() {
    if (this.filter) {
      this.injectComponent();
    }
  }

  ngOnChanges(): void {
    if (!this.component && this.filter) {
      this.injectComponent();
    }
  }

  ngOnDestroy(): void {
    this.filterComponent = null;
    if (this.component) {
      this.component.destroy();
    }
  }

  injectComponent() {
    if (this.hasBeenInjected) {
      return;
    }
    this.dynamicFilterComponentService.setRootViewContainerRef(this.card);
    this.component = this.dynamicFilterComponentService.addDynamicComponent(this.filter.name);
    if (this.component) {
      this.filterComponent = <BaseFilterComponent>this.component.instance;
      this.filterComponent.filter = this.filter;
      this.hasBeenInjected = true;
    }
  }
}
